import Awesomplete = require('awesomplete');

class ServiceGrouping {
    public groupingElement: HTMLElement;
    public serviceElements: HTMLElement[];
    public letterElement: HTMLElement;

    constructor(parentElement: HTMLElement, letter: string) {
        this.groupingElement = parentElement;

        this.serviceElements = Array.prototype.slice.call(this.groupingElement.getElementsByClassName("service-option-js"));
        // Only allow alphabetical characters
        if (/^[a-zA-Z]{1}$/.test(letter)) {
            this.letterElement = document.querySelector('a[data-group=' + letter + ']');
        }
        if (letter === "Other") {
            this.letterElement = document.querySelector('a[data-group=' + letter + ']');
        }
    }

    /**
     * Checks if the there exists any service under this group that is valid given the current configuration.
     */
    public get hasValidOptions(): boolean {
        return this.serviceElements.some(el => !el.classList.contains("hide"));
    }

    /**
     * Update the UI to hide services that don't contain the input string, and show services that do. If all services within a group
     * are invalid, the group is also hidden.
     * @param input
     */
    labelValidOptions(input: string) {
        for (let i = 0; i < this.serviceElements.length; ++i) {
            const curr = this.serviceElements[i];

            if (curr.getAttribute("data-service-name").indexOf(input) === -1) {
                curr.classList.add("hide");
                curr.setAttribute("aria-hidden", "true");
            } else {
                curr.classList.remove("hide");
                curr.removeAttribute("aria-hidden");
            }
        }

        if (!this.hasValidOptions) {
            this.groupingElement.classList.add("hide");
            this.letterElement.classList.add("disabled");
            this.groupingElement.setAttribute("aria-hidden", "true");
        } else {
            this.groupingElement.classList.remove("hide");
            this.letterElement.classList.remove("disabled");
            this.groupingElement.removeAttribute("aria-hidden");
        }
    }
}

const serviceGroups: ServiceGrouping[] = Array.prototype.slice.call(document.getElementsByClassName("service-group-js")).map(el => new ServiceGrouping(el, el.getAttribute("data-group")));
const serviceNames = Array.prototype.slice.call(document.getElementsByClassName("service-option-js")).map(el => el.getAttribute("data-service-name"));
const inputTextbox = document.getElementById("service-search-textbox-js") as HTMLInputElement;

let autocomplete = new Awesomplete(inputTextbox, {
    list: serviceNames
});

document.getElementById('service-search-form-js').addEventListener('submit', function (evt) {
    evt.preventDefault();
    const query = inputTextbox.value.toLowerCase();

    for (let i = 0; i < serviceGroups.length; ++i) {
        serviceGroups[i].labelValidOptions(query);
    }

    // Prevents Chrome for creating an autocomplete history for this form element
    // since the latest version of Chrome no longer respects autocomplete="off"
    inputTextbox.setAttribute('name', randomString(12));
});

inputTextbox.addEventListener('keyup', function () {
    if (inputTextbox.value == '') {
        for (let i = 0; i < serviceGroups.length; ++i) {
            serviceGroups[i].groupingElement.classList.remove('hide');
            serviceGroups[i].groupingElement.removeAttribute('aria-hidden');

            serviceGroups[i].serviceElements.forEach(serviceElement => {
                serviceElement.removeAttribute('aria-hidden');
                serviceElement.classList.remove('hide');
            })
        }
    }
});

document.querySelector('.adage-services-clear-js').addEventListener('click', function () {
    inputTextbox.value = '';
    for (let i = 0; i < serviceGroups.length; ++i) {
        if (!this.hasValidOptions) {
            this.groupingElement.classList.remove("hide");
            this.letterElement.classList.remove("disabled");
            this.groupingElement.removeAttribute("aria-hidden");
        }
    }
})


function randomString(length) {
    var randomString = '';
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (var i = 0; i < length; i++) {
        randomString += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return randomString;
}

// Prevents Chrome for creating an autocomplete history for this form element
// since the latest version of Chrome no longer respects autocomplete="off"
inputTextbox.setAttribute('name', randomString(12));

// Smooth scroll for alphabet links

let alphabetLinks = Array.prototype.slice.call(document.querySelectorAll('.adage-services-alphabet-link-js'));

alphabetLinks.forEach(link => {
    link.addEventListener('click', function (e) {
        e.preventDefault();

        let headerHeight = 0;
        let position = document.querySelector(link.getAttribute('href')).offsetTop;

        if (window.innerWidth < 960) {
            headerHeight = (document.querySelector('.header-top') as HTMLElement).offsetHeight;
        }
        else {
            headerHeight = (document.querySelector('.header-nav') as HTMLElement).offsetHeight;
        }

        window.scrollTo({
            top: position - headerHeight,
            behavior: 'smooth',
        });
    })
})